'use client'

import Link from 'next/link'

const Footer = () => {
	const currentYear = new Date().getFullYear()

	return (
		<footer className="py-12 border-t border-gray-200 dark:border-gray-800">
			<div className="section-container">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
					{/* Logo */}
					<div className="md:col-span-2">
						<Link href="/" className="text-xl font-semibold inline-block mb-3">
							<span className="animate-gradient-text">Da4ndo</span>
						</Link>
						<p className="text-sm text-gray-600 dark:text-gray-400 max-w-sm">
							Creating beautiful, functional, and user-centered digital experiences.
						</p>
					</div>

					{/* Quick links */}
					<div>
						<h3 className="font-semibold mb-4">Links</h3>
						<ul className="space-y-2 text-sm">
							{['About', 'Work', 'Skills', 'Contact'].map((item) => (
								<li key={item}>
									<Link href={`#${item.toLowerCase()}`} className="text-gray-600 dark:text-gray-400 hover:text-green-600 dark:hover:text-green-400 transition-colors">
										{item}
									</Link>
								</li>
							))}
						</ul>
					</div>

					{/* Social */}
					<div>
						<h3 className="font-semibold mb-4">Connect</h3>
						<ul className="space-y-2 text-sm">
							{[
								{ name: 'GitHub', url: 'https://github.com/da4ndo' },
								{ name: 'X', url: 'https://x.com/da4ndo005' },
								{ name: 'LinkedIn', url: 'https://www.linkedin.com/in/dániel-varga-7ab837358' }
							].map((social) => (
								<li key={social.name}>
									<a href={social.url} target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-green-600 dark:hover:text-green-400 transition-colors">
										{social.name}
									</a>
								</li>
							))}
						</ul>
					</div>
				</div>

				{/* Copyright */}
				<div className="pt-8 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-500 dark:text-gray-400">
					<p>© {currentYear} <span className="animate-gradient-text">Da4ndo</span>. All rights reserved.</p>
					<p className="mt-1">Built with Next.js and Motion</p>
				</div>
			</div>
		</footer>
	)
}

export default Footer
